import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Profile from "src/components/panel/profile/Profile";

const ProfileView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("profile_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("profile_title")}
          subtitle={t("profile_subtitle")}
        />
        <Profile />
      </Sidebar>
    </>
  );
};

export default ProfileView;
